module.exports = __webpack_public_path__ + "img/34352A_718184_50605E_6E6761-256px.f19fe1c1.png";